import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import { ProjectsWorkspace } from './projects/ProjectsWorkspace';

const Projects: React.FC = () => {
  return (
    <MainLayout title="Projects">
      <ProjectsWorkspace />
    </MainLayout>
  );
};

export default Projects;
